import { LoginProfileIcon, MasterAdminIcon } from '@/components';
import { PATHS } from '@/constants';
import { useAuth } from '@/contexts';
import { isMasterAdmin } from '@/contexts/auth/isMasterAdmin';
import { Button, Typography } from '@mui/material';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/navigation';
import { FC } from 'react';

export const AuthButton: FC<{ menuCloseCallback?: () => void }> = ({ menuCloseCallback }) => {
  const t = useTranslations();

  const router = useRouter();

  const { login, isAuthenticated, user } = useAuth();
  const showAdminBadge = isAuthenticated && isMasterAdmin(user?.role);

  const authHandler = () =>
    isAuthenticated ? router.push(`/${PATHS.PROFILE}/${PATHS.WATCH_LIST}`) : login();

  const handleClick = () => {
    menuCloseCallback?.();
    authHandler();
  };

  return (
    <Button
      variant="secondary"
      title=""
      sx={{
        height: '38px',
        padding: {
          xs: '10px',
          sm: undefined,
        },
      }}
      startIcon={showAdminBadge ? <MasterAdminIcon size={20} /> : <LoginProfileIcon />}
      onClick={handleClick}
    >
      <Typography fontSize={14} fontWeight={600}>
        {isAuthenticated ? user?.name : t('auth.loginAndRegister')}
      </Typography>
    </Button>
  );
};
